import { Heading, List, ListIcon, ListItem } from '@chakra-ui/react';
import { CheckedIcon } from '@udacity/chakra-uds-icons';

import { Markdown } from '~/components/markdown';
import { Feature } from '~/features/plans/models/plan-metadata';

export function FeatureList(props: { features: Feature[] }) {
  return (
    <List display='flex' flexDir='column' gap={2}>
      {props.features.map((feature, idx) => {
        return (
          <ListItem key={idx} display='flex'>
            <ListIcon as={CheckedIcon} color='blue.500' height='24px' width='24px' />
            <Markdown
              markdownText={feature.label}
              components={{
                p: ({ children }) => (
                  <Heading as='p' fontFamily='body' size='marketing-md'>
                    {children}
                  </Heading>
                ),
              }}
            />
          </ListItem>
        );
      })}
    </List>
  );
}
